import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_GDPR_USER_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import GdprUserHistory from '../../components/GdprUsersList/GdprUserHistory';

export const Route = createFileRoute('/_authenticated/gdpr-user/history')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_USER_LIST, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.gdpr/profile/history',
        suffix: 'menu.gdprUsersList',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: GdprUserHistoryRoute,
});

function GdprUserHistoryRoute() {
  return <GdprUserHistory />;
}
